import { render, staticRenderFns } from "./chakantupian.vue?vue&type=template&id=c5409b1a&scoped=true"
import script from "./chakantupian.vue?vue&type=script&lang=js"
export * from "./chakantupian.vue?vue&type=script&lang=js"
import style0 from "./chakantupian.vue?vue&type=style&index=0&id=c5409b1a&prod&scoped=true&lang=css"
import style1 from "./chakantupian.vue?vue&type=style&index=1&id=c5409b1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5409b1a",
  null
  
)

export default component.exports